/* eslint-disable */
import 'react-tippy/dist/tippy.css';
import '../../less/main.less';

import Route from './route.js';
Route.init();
